import React from "react";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleRight} from "@fortawesome/pro-solid-svg-icons";
import ENDPOINTS from "@/services/endpoints.ts";
import ImageLoader from "@/components/images/image-loader";
import ValidationPack from "../../../models/validation-pack.ts";

interface PackDetailsSlideProps {
    pack: ValidationPack;
    isFullScreen?: boolean;
}

const PackDetailsSlide: React.FC<PackDetailsSlideProps> = ({pack, isFullScreen}) => {
    
    const items = [
        {src: ENDPOINTS.PACK_IMAGE(
                pack.id,
                "ScopeStoreyByTgm"),
            title: "Scope StoreyByTgm"},
        {src: ENDPOINTS.PACK_IMAGE(
                pack.id,
                "ObjetsDeLancement"),
            title: "Objets de lancement",},
        {src: ENDPOINTS.PACK_IMAGE(
                pack.id,
                "Verticaux"),
            title: "Verticaux"},
        {src: ENDPOINTS.PACK_IMAGE(
                pack.id,
                "GrosOeuvre"),
            title: "Gros-oeuvre"},
        {src: ENDPOINTS.PACK_IMAGE(
                pack.id,
                "Enveloppes"),
            title: "Enveloppes"},
        {src: ENDPOINTS.PACK_IMAGE(
                pack.id,
                "Coques"),
            title: "Coques"},
        {src: ENDPOINTS.PACK_IMAGE(
                pack.id,
                "TypesDeCoque"),
            title: "Types de coque"}
    ];
    
    return (
        <>
            <style>{`
                .splide__pagination {
                    position: relative !important;
                    bottom: auto !important;
                    margin-top: 0.5rem;
                }
                
                .splide__pagination__page.is-active {
                    background: green;
                }
            `}</style>

            <Splide options={{type: 'fade'}}>
                {items.map((item, i) =>
                    <SplideSlide key={i}>
                        <div className='flex flex-col h-full'>
                            <div className={`min-h-0 w-full flex items-center justify-center transition-all duration-175 ease-in-out ${isFullScreen ? 'h-[calc(100vh-12.5rem)]' : 'h-48'}`}>
                                <ImageLoader src={item.src} className="w-full h-full object-contain"/>
                            </div>
                            <div className="font-medium text-lg text-center pt-2">{item.title}</div>
                        </div>
                    </SplideSlide>
                )}

                <div className="splide__arrows">
                    <button className="splide__arrow splide__arrow--prev !w-7 !h-7">
                        <FontAwesomeIcon icon={faAngleRight} className='text-xs'/>
                    </button>
                    <button className="splide__arrow splide__arrow--next !w-7 !h-7">
                        <FontAwesomeIcon icon={faAngleRight} className='text-xs'/>
                    </button>
                </div>
            </Splide>
        </>
  );
};

export default PackDetailsSlide;